import React from 'react';
import styled from 'styled-components';
import Dropdown from 'react-bootstrap/Dropdown';

const GRAVEDAD_STYLES = {
    CRITICA: { color: '#dc3545', icon: 'fas fa-exclamation-triangle' },
    GRAVE:   { color: '#fd7e14', icon: 'fas fa-exclamation-circle' },
    LEVE:    { color: '#ffc107', icon: 'fas fa-info-circle' },
    BAJA:    { color: '#17a2b8', icon: 'fas fa-check-circle' }
};

const Styles = styled.div`
    .traffic-row {
        border: 1px solid #e9ecef;
        border-left-width: 4px;
        border-radius: 6px;
        padding: 10px 12px;
        background: #fff;
        transition: box-shadow .15s ease;
    }
    .traffic-row:hover {
        box-shadow: 0 2px 6px rgba(0,0,0,.08);
    }
    .gravedad-title {
        font-weight: 600;
        letter-spacing: .3px;
        text-transform: uppercase;
        font-size: .85rem;
    }
    .traffic-nivel {
        text-align: center;
        border-radius: 4px;
        padding: 6px 4px;
        color: #fff;
        font-weight: 600;
        line-height: 1.1;
    }
    .traffic-nivel small {
        display: block;
        font-size: .65rem;
        opacity: .9;
        font-weight: 500;
    }
    .zona-label {
        font-size: .7rem;
        font-weight: 600;
        text-transform: uppercase;
        color: #6c757d;
        letter-spacing: .5px;
        margin-bottom: 4px;
    }
    .zona-label i {
        margin-right: 4px;
    }
    .tt-action-btn {
        border: none;
        background: transparent;
        color: #6c757d;
        padding: 4px 6px;
        border-radius: 4px;
    }
    .tt-action-btn:hover, .tt-action-btn:focus {
        background: #f1f3f5;
        color: #343a40;
        box-shadow: none;
    }
    .tt-action-btn::after {
        display: none;
    }
`;

function TrafficTimeCard({ item, onEditar, onEliminar, onVerHistorial }) {
    if (!item) return null;
    const style = GRAVEDAD_STYLES[item.gravedad_tt] || { color: '#6c757d', icon: 'fas fa-circle' };

    return (
        <Styles>
            <div className="traffic-row" style={{ borderLeftColor: style.color }}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div className="d-flex align-items-center">
                        <i className={`${style.icon} mr-2`} style={{ color: style.color }} />
                        <span className="gravedad-title" style={{ color: style.color }}>
                            {item.gravedad_tt}
                        </span>
                    </div>
                    <Dropdown alignRight>
                        <Dropdown.Toggle as="button" className="tt-action-btn" id={`dd-tt-${item.id_tt}`}>
                            <i className="fas fa-ellipsis-v" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            {onEditar && (
                                <Dropdown.Item onClick={() => onEditar(item)}>
                                    <i className="fas fa-edit mr-2 text-primary" />
                                    Editar
                                </Dropdown.Item>
                            )}
                            {onVerHistorial && (
                                <Dropdown.Item onClick={() => onVerHistorial(item)}>
                                    <i className="fas fa-history mr-2 text-info" />
                                    Ver historial
                                </Dropdown.Item>
                            )}
                            {onEliminar && (
                                <>
                                    <Dropdown.Divider />
                                    <Dropdown.Item onClick={() => onEliminar(item)}>
                                        <i className="fas fa-trash mr-2 text-danger" />
                                        Eliminar
                                    </Dropdown.Item>
                                </>
                            )}
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="mb-2">
                    <div className="zona-label">
                        <i className="fas fa-city text-primary" />
                        Capital
                    </div>
                    <div className="row no-gutters">
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#28a745' }}>
                                {item.nivelVerdeHoursCapital_tt ?? '-'}
                                <small>Verde (hs)</small>
                            </div>
                        </div>
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#ffc107', color: '#212529' }}>
                                {item.nivelAmarilloHoursCapital_tt ?? '-'}
                                <small>Amarillo (hs)</small>
                            </div>
                        </div>
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#fd7e14' }}>
                                {item.nivelNaranjaHoursCapital_tt ?? '-'}
                                <small>Naranja (hs)</small>
                            </div>
                        </div>
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#dc3545' }}>
                                {item.nivelRojoHoursCapital_tt ?? '-'}
                                <small>Rojo (hs)</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="zona-label">
                        <i className="fas fa-globe-americas text-success" />
                        Interior
                    </div>
                    <div className="row no-gutters">
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#28a745' }}>
                                {item.nivelVerdeHours_tt ?? '-'}
                                <small>Verde (hs)</small>
                            </div>
                        </div>
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#ffc107', color: '#212529' }}>
                                {item.nivelAmarilloHours_tt ?? '-'}
                                <small>Amarillo (hs)</small>
                            </div>
                        </div>
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#fd7e14' }}>
                                {item.nivelNaranjaHours_tt ?? '-'}
                                <small>Naranja (hs)</small>
                            </div>
                        </div>
                        <div className="col-3 px-1">
                            <div className="traffic-nivel" style={{ backgroundColor: '#dc3545' }}>
                                {item.nivelRojoHours_tt ?? '-'}
                                <small>Rojo (hs)</small>
                            </div>
                        </div>
                    </div>
                </div>
                {item.creadoPor?.nombre_p && (
                    <div className="mt-2 text-right">
                        <small className="text-muted">
                            <i className="fas fa-user mr-1" />
                            {item.creadoPor.nombre_p}
                        </small>
                    </div>
                )}
            </div>
        </Styles>
    );
}

TrafficTimeCard.defaultProps = {
    item: null,
    onEditar: null,
    onEliminar: null,
    onVerHistorial: null
};

export default TrafficTimeCard;
